import { Api } from '../api';
import { profile } from '../endpoints';
import type {
  ChangePasswordRequest,
  ChangeProfileRequest,
  GetProfile,
  PostC2cPaymentUrlRequest,
  PostC2cPaymentUrlResponse,
  postSecurityQuestionsRequest,
} from './models';

export class ProfileApi extends Api {
  static getProfile = (signal?: AbortSignal) => this.get<GetProfile>({ url: profile.profile(), signal: signal });

  static changeProfile = (request: ChangeProfileRequest, signal?: AbortSignal) =>
    this.post<ChangeProfileRequest, undefined>({ url: profile.profile(), data: request, signal: signal });

  static changePassword = (request: ChangePasswordRequest, signal?: AbortSignal) =>
    this.post<ChangePasswordRequest, undefined>({ url: profile.changePassword(), data: request, signal: signal });

  static getSecurityQuestions = (signal?: AbortSignal) => this.get<string[]>({ url: profile.securityQuestions(), signal: signal });

  static postSecurityQuestions = (request: postSecurityQuestionsRequest, signal?: AbortSignal) =>
    this.post<postSecurityQuestionsRequest, undefined>({ url: profile.securityQuestions(), data: request, signal: signal });

  static postc2cpaymenturl = (request: PostC2cPaymentUrlRequest, signal?: AbortSignal) =>
    this.post<PostC2cPaymentUrlRequest, PostC2cPaymentUrlResponse>({ url: profile.getc2cpaymenturl(), data: request, signal: signal });

  static getc2cfeepercent = (signal?: AbortSignal) => this.get<number>({ url: profile.getc2cfeepercent(), signal: signal });
}
